import { Injectable } from '@angular/core';
import { AppliedFilter, FilterCriteria } from '@shared/components/filters/Domain/filter.model';

@Injectable({ providedIn: 'root' })
export class FiltersUtilsService {
  mapFiltersToSearchCriteria(saved: AppliedFilter[]): FilterCriteria {
    const filters: { [key: string]: any } = {};

    const ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/;

    for (const item of saved) {
      const filter = item.filter;
      if (!item.isApplied || !filter?.id) continue;

      if (filter.id === 'workflows') {
        //TO THE FUTURE: CREATE A CASCADE FILTER OUT OF PRIMENG
        const value = item.value;

        let operation: string = '';
        let ids: string[] = [];

        // Case 1: Already normalized (e.g., from session storage)
        if (value?.operation && Array.isArray(value?.ids)) {
          operation = value.operation;
          ids = value.ids.filter((id: string) => typeof id === 'string' && ulidRegex.test(id));
        }

        // Case 2: Raw array format (e.g., from filter UI)
        else if (Array.isArray(value)) {
          const operationItem = value.find((v: any) => v.dropdown === 'dropdown-0');
          operation = operationItem?.value || '';

          ids = value
            .filter((v: any) => v.dropdown === 'dropdown-1')
            .map((v: any) => v.value)
            .filter((v: any) => typeof v === 'string' && ulidRegex.test(v));
        }

        if (ids.length > 0 && operation) {
          filters['workflows'] = { operation, ids };
        }
      } else {
        filters[filter.id] = item.value;
      }
    }

    return filters;
  }
}
